import { createAction, props } from '@ngrx/store';
import { UserGroupModel } from '@shared/data-access/models';

export const getDetail = createAction('[User Group] GET DETAIL', props<{ item: UserGroupModel }>());
